import { render, staticRenderFns } from "./ProcessadosSemestral.vue?vue&type=template&id=163f53b4&scoped=true&"
import script from "./ProcessadosSemestral.vue?vue&type=script&lang=js&"
export * from "./ProcessadosSemestral.vue?vue&type=script&lang=js&"
import style0 from "./ProcessadosSemestral.vue?vue&type=style&index=0&id=163f53b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f53b4",
  null
  
)

export default component.exports